import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MUIAccordion from '@mui/material/Accordion';
import MUIAccordionDetails from '@mui/material/AccordionDetails';
import MUIAccordionSummary from '@mui/material/AccordionSummary';
import React from 'react';

type AccordionProps = {
  children: React.ReactNode;
  header: React.ReactNode;
  defaultExpanded?: boolean;
} & Partial<React.ComponentProps<typeof MUIAccordion>>;

export const Accordion = ({
  children,
  header,
  defaultExpanded,
  sx,
  ...props
}: AccordionProps) => {
  return (
    <MUIAccordion
      defaultExpanded={defaultExpanded}
      elevation={0}
      sx={{
        '&.MuiAccordion-root': {
          borderRadius: '4px',
          overflow: 'hidden',
          border: ({ palette }) => `1px solid ${palette.gray[200]}`,
        },
        '&.Mui-expanded': {
          margin: 0,
        },
        ...sx,
      }}
      {...props}
    >
      <MUIAccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          '&.MuiAccordionSummary-root': {
            backgroundColor: ({ palette }) => palette.gray[50],
            px: 4,
            py: 3,
            fontSize: '20px',
            fontWeight: 500,
            margin: '0 !important',
          },
          margin: 0,
          '&.Mui-expanded': {
            margin: 0,
            minHeight: 0,
            borderBottom: ({ palette }) => `1px solid ${palette.gray[200]}`,
            marginTop: 0,
          },
          '& .MuiAccordionSummary-content': {
            margin: '0 !important',
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            color: 'black',
          },
        }}
      >
        {header}
      </MUIAccordionSummary>
      <MUIAccordionDetails
        sx={{
          padding: 8,
        }}
      >
        {children}
      </MUIAccordionDetails>
    </MUIAccordion>
  );
};
